import React, {
  Component
} from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import RegisterLayout from '../layouts/RegisterLayout';
import Addobserver from './Addobserver';
import Pinregistration from './Pinregistration';
import Registeruserdetails from './Registeruserdetails';
import Thankspage from './Thankspage';
const $ = window.$;

export default class Register extends Component {

  constructor(props) {
    super(props);
    //Registrationpanel: <Pinregistration  backToPreviousPage={(e)=>this.backToLogin(e)} submit={(e)=>this.submitStep1()} onChange={(e)=>this.handleChange(e)} />,

    // <Registeruserdetails buttonText="Complete Registration" data={[]} submit={(e)=>this.submitStep2()} onChange={(e)=>this.handleChange(e)}/>

    // <Pinregistration  backToPreviousPage={(e)=>this.backToLogin(e)} submit={(e)=>this.submitStep1()} onChange={(e)=>this.handleChange(e)} />

    this.state = {
      register_details_button: 'Complete Registration',
      Registrationpanel: <Pinregistration backToPreviousPage={(e) => this.backToLogin(e)} submit={(e) => this.submitStep1()} onChange={(e) => this.handleChange(e)} />,
      content: [],
      email: '',
      pin: '',
      key: '',
      registration_details: []
    };
    // this.handleChange=this.handleChange.bind(this);
  }



  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  submitStep1() {

    let username = "";
    let pin = "";
    let userkey = "";
    if (document.getElementById('email').value === '') {
      username = this.state.pin;
    }
    else {
      username = document.getElementById('email').value;
    }
    if (document.getElementById('pin').value === '') {
      pin = this.state.pin;
    }
    else {
      pin = document.getElementById('pin').value;
    }
    if (document.getElementById('Key').value === '') {
      userkey = this.state.pin;
    }
    else {
      userkey = document.getElementById('Key').value;
    }

    Common.reactLoader("show", "Please wait...");
    fetch(Config.domainUrl + "user/pinregister", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        //  pin:this.state.pin,
        //  key:this.state.key,
        //  email:this.state.email
        pin: pin,
        key: userkey,
        email: username
      })
    }).then((response) => response.json()).then((responseJson) => {

      Common.reactLoader("hide");

      if (responseJson.status === 0) {

        if (responseJson.errors !== "") {

          Common.message(responseJson.message, responseJson.errors, 'error');
        } else {
          Common.message("Oops!!", responseJson.message, 'error');
        }


      } else {
        let register_details_button = this.state.register_details_button;
        if (responseJson.LearnerData.buttonvalue === 1) {
          register_details_button = "Next";
        }

        this.setState({ register_details_button: register_details_button });

        this.setState({
          Registrationpanel: <Registeruserdetails buttonText={register_details_button} data={responseJson.LearnerData} submit={(e) => this.submitStep2()} onChange={(e) => this.handleChange(e)} />
        });

      }
    });


  }

  submitStep2() {
    Common.reactLoader("show", "Please wait...");
    let formData = new FormData();
    let registration_details = $('#registration_details').serializeArray();



    registration_details.map((key, index) => {
      if (key.name === 'hidfilename') { return false; }

      formData.append(key.name, key.value);
    });



    if ($('#txtfile')[0].files.length > 0) {
      formData.append('txtfile', $('#txtfile')[0].files[0]);
    } else {

      formData.append('txtfile', '');
    }



    fetch(Config.domainUrl + "user/registerdetails", {
      method: "POST",
      // data: formData,

      headers: {
        'Accept': 'application/json',
        // 'Content-Type': false

      },
      body: formData,
    }).then((response) => response.json()).then((responseJson) => {
      Common.reactLoader("hide");

      if (responseJson.status === 0) {

        Common.message(responseJson.message, responseJson.errors, 'error');

      } else {
        // Common.message('',responseJson.message,'success');

        if (this.state.register_details_button === "Next") {

          this.setState({
            LearnerData: responseJson.data,
            Registrationpanel: <Addobserver data={responseJson.data} submit={(e) => this.submitStep3()} onChange={(e) => this.handleChange(e)} />
          });

        } else {

          this.setState({
            LearnerData: responseJson.data,
            Registrationpanel: <Thankspage data={responseJson.data} />
          });

        }

      }



    });



    // let registration_details=$('#registration_details').serializeArray();
    // console.log(registration_details);

    //  this.setState({
    //   step2:'none',
    //   step3:''
    // });
  }

  submitStep3() {
    Common.reactLoader("show", "Please wait...");
    let formData = new FormData();
    let frmaddobserver = $('#frmaddobserver').serializeArray();


    frmaddobserver.map((key, index) => {
      if (key.name === 'hidfilename') { return false; }

      formData.append(key.name, key.value);
    });


    fetch(Config.domainUrl + "user/addobservers", {
      method: "POST",
      // data: formData,

      headers: {
        'Accept': 'application/json',
        // 'Content-Type': false

      },
      body: formData,
    }).then((response) => response.json()).then((responseJson) => {
      Common.reactLoader("hide");

      if (responseJson.status === 0) {

        Common.message(responseJson.message, responseJson.errors, 'error');

      } else {
        this.setState({
          Registrationpanel: <Thankspage data={this.state.LearnerData} />
        });
      }


    });



  }

  backToPreviousPage(step) {
    if (step === 1) {
      this.setState({
        step1: '',
        step2: 'none'
      });
    }
  }

  backToLogin() {
    this.props.router.push('/');
  }

  render() {

    // <Registeruserdetails buttonText={this.state.register_details_button} display={this.state.step2}  data={this.state.learnerData} submit={(e)=>this.submitStep2()} onChange={(e)=>this.handleChange(e)} />
    //
    // <Addobserver  display={this.state.step3} submit={(e)=>this.submitStep3()} onChange={(e)=>this.handleChange(e)} />
    //
    // <Thankspage data={this.state.content} display={this.state.step4} />
    //

    return (
      <RegisterLayout>
        {this.state.Registrationpanel}
      </RegisterLayout>
    );
  }

}



// WEBPACK FOOTER //
// ./src/auth/Register.js